import React from 'react';
import { observer } from 'mobx-react-lite';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Tooltip from '@material-ui/core/Tooltip';
import { useTranslation } from 'react-i18next';
import styles from './AutoReplyWeeklyScheduled.module.css';
import AutoReplyWeeklyScheduledSwitches from '../AutoReplyWeeklyScheduledSwitches/AutoReplyWeeklyScheduledSwitches';
import AutoReplyEditButtons from '../AutoReplyEditButtons/AutoReplyEditButtons';
import {
  checkIfScheduledAutoReplyIsOverriddenByCustomAwayMessage,
  hasAwayMessageAutoReplyExpired,
} from '../../../../../helpers/dateHelpers';
import * as utils from '../../../../../helpers/utils';

const tableRow = {
  root: styles.tableRow,
};

const tableRowOverridden = {
  root: styles.tableRowOverridden,
};

const tableCell = {
  root: styles.tableCell,
};

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const AutoReplyWeeklyScheduled = observer(function AutoReplyWeeklyScheduled(props) {
  const { data, activeTextCustomAwayMessage, activeWebCustomAwayMessage } = props;

  const { t } = useTranslation();

  // React.useEffect(() => {
  //   let timeout;
  //   if (
  //     data?.ExpirationTime &&
  //     (data?.IsActiveForTextChat || data?.IsActiveForWebChat) &&
  //     !dayjs(data.ExpirationTime).isBefore(dayjs())
  //   ) {
  //     const timeDifference = dayjs(data.ExpirationTime).diff(dayjs());
  //     timeout = setTimeout(() => {}, timeDifference);
  //   }

  //   return () => {
  //     clearTimeout(timeout);
  //   };
  // }, [data?.ExpirationTime, data?.IsActiveForTextChat, data?.IsActiveForWebChat]);

  const isOverriddenByTextCustomAwayMessageAutoReply = checkIfScheduledAutoReplyIsOverriddenByCustomAwayMessage(
    activeTextCustomAwayMessage,
    data
  );

  const isOverriddenByWebCustomAwayMessageAutoReply = checkIfScheduledAutoReplyIsOverriddenByCustomAwayMessage(
    activeWebCustomAwayMessage,
    data
  );

  const isTextCustomAwayMessageAutoReplyExpired = hasAwayMessageAutoReplyExpired(
    activeTextCustomAwayMessage?.ExpirationTime
  );

  const isWebCustomAwayMessageAutoReplyExpired = hasAwayMessageAutoReplyExpired(
    activeWebCustomAwayMessage?.ExpirationTime
  );

  // grays out only if both are overridden
  let tableRowClass;
  if (
    isOverriddenByTextCustomAwayMessageAutoReply &&
    isOverriddenByWebCustomAwayMessageAutoReply &&
    !isTextCustomAwayMessageAutoReplyExpired &&
    !isWebCustomAwayMessageAutoReplyExpired
  ) {
    tableRowClass = tableRowOverridden;
  } else if (
    !isOverriddenByTextCustomAwayMessageAutoReply &&
    !isOverriddenByWebCustomAwayMessageAutoReply
  ) {
    tableRowClass = tableRow;
  }

  // always grays out row
  // (isOverriddenByTextCustomAwayMessageAutoReply ||
  //   isOverriddenByWebCustomAwayMessageAutoReply) &&
  // (!isTextCustomAwayMessageAutoReplyExpired || !isWebCustomAwayMessageAutoReplyExpired)
  //   ? tableRowOverridden
  //   : tableRow

  return (
    <TableRow key={data._id} classes={tableRowClass}>
      <TableCell classes={tableCell} style={{ width: 166 }}>
        <div className={[styles.tableCellItem, styles.tableCellItemStart, styles.bold].join(' ')}>
          <AutoReplyWeeklyScheduledSwitches
            data={data}
            overriddenByTextAutoReplyTitle={activeTextCustomAwayMessage?.Title}
            overriddenByWebAutoReplyTitle={activeWebCustomAwayMessage?.Title}
            isOverriddenByTextCustomAwayMessageAutoReply={
              isOverriddenByTextCustomAwayMessageAutoReply
            }
            isOverriddenByWebCustomAwayMessageAutoReply={
              isOverriddenByWebCustomAwayMessageAutoReply
            }
            isTextCustomAwayMessageAutoReplyExpired={isTextCustomAwayMessageAutoReplyExpired}
            isWebCustomAwayMessageAutoReplyExpired={isWebCustomAwayMessageAutoReplyExpired}
          />
        </div>
      </TableCell>
      <TableCell classes={tableCell} style={{ width: 201 }}>
        <div className={[styles.tableCellItem, styles.bold].join(' ')}>
          <span className={styles.tableData}>{data.Title}</span>
        </div>
      </TableCell>
      <TableCell classes={tableCell} style={{ width: 328 }}>
        <div className={styles.tableCellItem}>
          {utils.getFormattedRecurringStatus(data.RecurringStatus).map((m, k) => (
            // eslint-disable-next-line react/no-array-index-key
            <span key={k} className={styles.tableData}>
              {m}
            </span>
          ))}
        </div>
      </TableCell>
      <TableCell classes={tableCell}>
        <div className={styles.tableCellItem}>
          <span className={styles.tableData}>{data.Message}</span>
        </div>
      </TableCell>
      <TableCell classes={tableCell} style={{ width: 70 }}>
        <div className={[styles.tableCellItem, styles.tableCellItemEnd].join(' ')}>
          {!data.IsDefault ? (
            <AutoReplyEditButtons data={data} />
          ) : (
            <Tooltip
              arrow
              enterDelay={1000}
              title={t('AutoReplyWeeklyScheduled.DefaultAutoReplyDescription')}
              placement="left"
            >
              <div className={styles.helpIcon} />
            </Tooltip>
          )}
        </div>
      </TableCell>
    </TableRow>
  );
});
AutoReplyWeeklyScheduled.whyDidYouRender = true;
AutoReplyWeeklyScheduled.displayName = 'AutoReplyWeeklyScheduled';

export default AutoReplyWeeklyScheduled;
